import React, { Component } from 'react';
import { Modal, Button, Input, message, Radio, Spin } from 'antd';
import RequirementDescribe from './RequirementDescribe';
import RequirementInformation from './RequirementInformation';
// import AdjustFte from './AdjustFte';
import AssignedUser from '../tables/AssignedUser';
import InvestigationInfo from '../tables/InvestigationInfo';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

const { TextArea } = Input;
const RadioGroup = Radio.Group;
const Default = {
    '1': '同意分配',
    '0': '拒绝分配',
};
const DefaultState = {
    investigation: {},
    detailParams: {},
    requirementPiList: [],
    assignmentList: [],
    preAssignmentList: [],
};

const genOptions = data => Object.keys(data).map(i => <Radio key={i} value={i}>{ data[i] }</Radio>);

const DefaultOption = genOptions(Default, 'radio');

class UserDistribute extends Component {
    state = {
        visible: false,
        loading: false,
        data: {},
        params: {},
       ...DefaultState,
    }

    queryDetail = () => {
        const { params: { requirementId, requirementInfos } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.member.getRequirementDetail,
            data: { requirementId },
            doneResult: res => {
                const {
                    requirement,
                    requirementPiList,
                    assignmentList,
                    preAssignmentList,
                } = res.data;
                const {
                    site,
                    requirementExplain,
                    requirementComment,
                    requirementInfo,
                    requirementCode,
                    requireUserCode,
                    requireUser,
                } = requirement || {};
                const {
                    city,
                    investigation,
                    investigationSiteName,
                    courtyardArea,
                    departmentName,
                } = site || {};
                const detailParams = {
                    city,
                    requireUser,
                    requireUserCode,
                    requirementCode,
                    requirementExplain,
                    requirementComment,
                    investigationSiteName,
                    courtyardArea,
                    departmentName,
                    ...requirementInfo,
                };
                const { current, ...rest } = requirementInfos;
                detailParams.requirementInfos = current ? { [current]: rest[current] } : rest;
                
                this.setState({
                    loading: false,
                    investigation,
                    detailParams,
                    requirementPiList,
                    assignmentList,
                    preAssignmentList,
                });
            },
        };
        $.sendRequest(options);
    }

    show = (params) => {
        this.setState({
            params,
            visible: true,
        }, () => {
            this.queryDetail();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            data: {},
            ...DefaultState,
        });
    }

    handleChange = (value, key) => {
        const { data } = this.state;

        switch(key) {
            default:
                data[key] = value;
                this.setState({ data });
        }
    }

    adjustFte = () => {
        const { preAssignmentList } = this.state;
        this.adjustFteRef.show(preAssignmentList);
    }

    handleSubmit = () => {
        const { data, params: { requirementId } } = this.state;
        const { isAgree, reason } = data;
        if (!isAgree) {
            return message.warning('请选择处理意见');
        }
        if (isAgree && isAgree == 0 && !reason) {
            return message.warning("请填写拒绝原因");
        }
        const url = isAgree == 0 ? API_URL.member.refuseRequirement : API_URL.member.confirmRequirement;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: {
                reason,
                requirementId,
            },
            doneResult: () => {
                message.success('操作成功');
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { showEmployeeDetail } = this.props;
        const {
            visible,
            loading,
            data,
            params,
            investigation,
            detailParams,
            assignmentList,
            preAssignmentList,
            requirementPiList,
        } = this.state;
        const { investigationId } = params;
        return (
            <Modal
                title='处理人员分配'
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                bodyStyle={{ maxHeight: 600 }}
                confirmLoading={loading}
                maskClosable={false}
                width="1000px"
            >
                <Spin spinning={loading}>
                    <div style={{ lineHeight: '32px' }}>1.项目概要信息</div>
                    <InvestigationInfo data={investigation} />
                    <RequirementDescribe visible={visible} investigationId={investigationId} />
                    <div style={{ lineHeight: '32px' }}>2.需求信息</div>
                    <RequirementInformation data={detailParams} piList={requirementPiList} />
                    {
                        (assignmentList || []).length > 0 &&
                        <div>
                            <div style={{ marginTop: 20, paddingTop: 10, lineHeight: '32px', borderTop: '1px solid #d1d1d1' }}>已分配情况</div>
                            <AssignedUser data={assignmentList} showEmployeeDetail={showEmployeeDetail} />
                        </div>
                    }
                    <div
                        style={{
                            marginTop: 20, paddingTop: 10,
                            lineHeight: '32px', borderTop: '1px solid #d1d1d1',
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                        }}
                    >
                        预分配情况
                        {/* <Button type="primary" onClick={this.adjustFte}>调整FTE</Button> */}
                    </div>
                    <AssignedUser data={preAssignmentList} isPrev={true} showEmployeeDetail={showEmployeeDetail} />
                    <div style={{ lineHeight: '48px', borderBottom: '1px solid #d1d1d1' }}>补充说明：{detailParams.requirementExplain}</div>
                    <div style={{ lineHeight: '48px' }}>
                        处理意见：
                        <RadioGroup
                            value={data.isAgree}
                            onChange={e => this.handleChange(e.target.value, 'isAgree')}
                        >
                            { DefaultOption }
                        </RadioGroup>
                    </div>
                    {
                        data.isAgree == 0 &&
                        <div style={{ marginLeft: 60, marginBottom: 20 }}>
                            <TextArea
                                rows={4}
                                placeholder='请填写拒绝原因'
                                value={data.reason}
                                onChange={e => this.handleChange(e.target.value, 'reason')}
                            />
                        </div>
                    }
                </Spin>
                {/* <AdjustFte ref={el => this.adjustFteRef = el} loadData={this.queryDetail} /> */}
            </Modal>
        );
    }
}

export default UserDistribute;



// WEBPACK FOOTER //
// ./src/components/user/require/components/UserDistribute.js